import { getCookieValue } from '../../util/cookies';

const initializeGaHelper = () => {
  const googleClientId = getCookieValue('_ga');
  const googleSessionId = getCookieValue('_ga_02SXDH1H96');

  const googleClientIdFields = document.querySelectorAll(
    "input[name='google_client_id']"
  );
  const googleSessionIdFields = document.querySelectorAll(
    "input[name='google_session_id']"
  );

  googleClientIdFields.forEach((field) => {
    field.value = googleClientId;
  });

  googleSessionIdFields.forEach((field) => {
    field.value = googleSessionId;
  });
};

export { initializeGaHelper };
